import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { CustomTab } from 'components';

const HomologacionTabScreen = () => {
  const navigate = useNavigate();
  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Proveedores",
            route: '/admin/homologacion',
            onChange: () => navigate('/admin/homologacion'),
            content: <Outlet />
          },
          {
            name: "Pendientes",
            route: '/admin/homologacion/pendientes',
            onChange: () => navigate('pendientes'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default HomologacionTabScreen